import { gql } from '@apollo/client';

export default gql`
  mutation addVoucherNote($voucherAlias: String!, $message: String!) {
    addVoucherNote(voucherAlias: $voucherAlias, message: $message) {
      id
      content
      createdAt
      createdBy
    }
  }
`;
